import { render, staticRenderFns } from "./box-9-unit-3.vue?vue&type=template&id=7bbbd22d&scoped=true&"
import script from "./box-9-unit-3.vue?vue&type=script&lang=ts&"
export * from "./box-9-unit-3.vue?vue&type=script&lang=ts&"
import style0 from "./box-9-unit-3.vue?vue&type=style&index=0&id=7bbbd22d&lang=scss&scoped=true&"
import style1 from "./box-9-unit-3.vue?vue&type=style&index=1&id=7bbbd22d&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bbbd22d",
  null
  
)

export default component.exports